export default __webpack_public_path__ + "static/logo-9166dc74d2ba894c106accf246be8609.png";